const SECTIONS = {
  "CT": { name: "Connecticut", center: [41.6032, -73.0877] },
  "EMA": { name: "Eastern Massachusetts", center: [42.4072, -71.3824] },
  "ME": { name: "Maine", center: [45.2538, -69.4455] },
  "NH": { name: "New Hampshire", center: [43.1939, -71.5724] },
  "RI": { name: "Rhode Island", center: [41.5801, -71.4774] },
  "VT": { name: "Vermont", center: [44.5588, -72.5778] },
  "WMA": { name: "Western Massachusetts", center: [42.1015, -72.5898] },
  "ENY": { name: "Eastern New York", center: [42.6526, -73.7562] },
  "NLI": { name: "NYC-Long Island", center: [40.7891, -73.1350] },
  "NNJ": { name: "Northern New Jersey", center: [40.8568, -74.2263] },
  "NNY": { name: "Northern New York", center: [44.2795, -75.3326] },
  "SNJ": { name: "Southern New Jersey", center: [39.8338, -74.8710] },
  "WNY": { name: "Western New York", center: [42.8864, -78.8784] },
  "DE": { name: "Delaware", center: [38.9108, -75.5277] },
  "EPA": { name: "Eastern Pennsylvania", center: [40.5773, -75.4902] },
  "MDC": { name: "Maryland-DC", center: [39.0458, -76.6413] },
  "WPA": { name: "Western Pennsylvania", center: [40.4406, -79.9959] },
  "AL": { name: "Alabama", center: [32.3182, -86.9023] },
  "GA": { name: "Georgia", center: [32.1656, -82.9001] },
  "KY": { name: "Kentucky", center: [37.8393, -84.2700] },
  "NC": { name: "North Carolina", center: [35.7596, -79.0193] },
  "NFL": { name: "Northern Florida", center: [30.3322, -81.6557] },
  "SC": { name: "South Carolina", center: [33.8361, -81.1637] },
  "SFL": { name: "Southern Florida", center: [25.7617, -80.1918] },
  "WCF": { name: "West Central Florida", center: [27.9506, -82.4572] },
  "TN": { name: "Tennessee", center: [35.5175, -86.5804] },
  "VA": { name: "Virginia", center: [37.4316, -78.6569] },
  "PR": { name: "Puerto Rico", center: [18.2208, -66.5901] },
  "VI": { name: "Virgin Islands", center: [18.3358, -64.8963] },
  "AR": { name: "Arkansas", center: [35.2010, -91.8318] },
  "LA": { name: "Louisiana", center: [30.9843, -91.9623] },
  "MS": { name: "Mississippi", center: [32.3547, -89.3985] },
  "NM": { name: "New Mexico", center: [34.5199, -105.8701] },
  "NTX": { name: "North Texas", center: [32.7767, -96.7970] },
  "OK": { name: "Oklahoma", center: [35.4676, -97.5164] },
  "STX": { name: "South Texas", center: [29.4241, -98.4936] },
  "WTX": { name: "West Texas", center: [31.7619, -106.4850] },
  "EB": { name: "East Bay", center: [37.8044, -122.2712] },
  "LAX": { name: "Los Angeles", center: [34.0522, -118.2437] },
  "ORG": { name: "Orange", center: [33.7175, -117.8311] },
  "SB": { name: "Santa Barbara", center: [34.4208, -119.6982] },
  "SCV": { name: "Santa Clara Valley", center: [37.3541, -121.9552] },
  "SDG": { name: "San Diego", center: [32.7157, -117.1611] },
  "SF": { name: "San Francisco", center: [37.7749, -122.4194] },
  "SJV": { name: "San Joaquin Valley", center: [36.7378, -119.7871] },
  "SV": { name: "Sacramento Valley", center: [38.5816, -121.4944] },
  "PAC": { name: "Pacific", center: [13.4443, 144.7937] },
  "AZ": { name: "Arizona", center: [34.0489, -111.0937] },
  "EWA": { name: "Eastern Washington", center: [47.6588, -117.4260] },
  "ID": { name: "Idaho", center: [44.0682, -114.7420] },
  "MT": { name: "Montana", center: [46.8797, -110.3626] },
  "NV": { name: "Nevada", center: [38.8026, -116.4194] },
  "OR": { name: "Oregon", center: [43.8041, -120.5542] },
  "UT": { name: "Utah", center: [39.3210, -111.0937] },
  "WWA": { name: "Western Washington", center: [47.6062, -122.3321] },
  "WY": { name: "Wyoming", center: [43.0760, -107.2903] },
  "AK": { name: "Alaska", center: [64.2008, -152.4937] },
  "MI": { name: "Michigan", center: [44.3148, -85.6024] },
  "OH": { name: "Ohio", center: [40.4173, -82.9071] },
  "WV": { name: "West Virginia", center: [38.5976, -80.4549] },
  "IL": { name: "Illinois", center: [40.6331, -89.3985] },
  "IN": { name: "Indiana", center: [40.2672, -86.1349] },
  "WI": { name: "Wisconsin", center: [43.7844, -88.7879] },
  "CO": { name: "Colorado", center: [39.5501, -105.7821] },
  "IA": { name: "Iowa", center: [41.8780, -93.0977] },
  "KS": { name: "Kansas", center: [39.0119, -98.4842] },
  "MN": { name: "Minnesota", center: [46.7296, -94.6859] },
  "MO": { name: "Missouri", center: [37.9643, -91.8318] },
  "NE": { name: "Nebraska", center: [41.4925, -99.9018] },
  "ND": { name: "North Dakota", center: [47.5515, -101.0020] },
  "SD": { name: "South Dakota", center: [43.9695, -99.9018] },
  "NL": { name: "Newfoundland/Labrador", center: [53.1355, -57.6604] },
  "NB": { name: "New Brunswick", center: [46.5653, -66.4619] },
  "NS": { name: "Nova Scotia", center: [44.6820, -63.7443] },
  "PE": { name: "Prince Edward Island", center: [46.5107, -63.4168] },
  "QC": { name: "Quebec", center: [46.8139, -71.2080] },
  "ONE": { name: "Ontario East", center: [44.9, -76.5] },
  "ONN": { name: "Ontario North", center: [49.0, -83.0] },
  "ONS": { name: "Ontario South", center: [43.5, -80.5] },
  "GH": { name: "Golden Horseshoe", center: [43.6532, -79.3832] },
  "MB": { name: "Manitoba", center: [53.7609, -98.8139] },
  "SK": { name: "Saskatchewan", center: [52.9399, -106.4509] },
  "AB": { name: "Alberta", center: [53.9333, -116.5765] },
  "BC": { name: "British Columbia", center: [53.7267, -127.6476] },
  "TER": { name: "Territories", center: [64.8255, -124.8457] },
  "DX": { name: "DX", center: [0, 0] }
};

const SECTION_COLORS = [
  '#22d3ee', '#34d399', '#a78bfa', '#fb923c', 
  '#f472b6', '#facc15', '#60a5fa', '#4ade80',
  '#c084fc', '#f87171', '#2dd4bf', '#fbbf24'
];

export function getSectionColor(section, workedSections) {
  const workedList = Object.keys(workedSections).sort();
  const index = workedList.indexOf(section);
  if (index === -1) return null;
  return SECTION_COLORS[index % SECTION_COLORS.length];
}

export function getSectionCenter(section) {
  return SECTIONS[section]?.center || null;
}

export function getSectionName(section) {
  return SECTIONS[section]?.name || section;
}

export function getAllSections() {
  return SECTIONS;
}

export default SECTIONS;
